module.exports = __webpack_public_path__ + "img/b2964324c0c10c22299704569f1c7a51.png";